
import axios, { AxiosResponse } from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import WsdlService from "@/services/WsdlService";
import Option from "@/models/SelectOption";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import FundType from "@/models/WsdlResponses/FundType";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

@Component({
    components: { DatePicker },

})
export default class ConsultaTuCuentaForm extends Vue {
	@Prop() isProcessing: boolean;

    public tiposDeFondos: Array<Option<FundType>> = [];
    public tipoFondo: FundType = new FundType();
    public wsdlService: WsdlService = new WsdlService();
    public userId: string = this.$store.state.user.cedula;
	public fromDate: string = "";
	public toDate: string = "";
	public todaysDate: Date = new Date();
	public initialDate: Date = new Date();

    constructor() {
        super();
    }
    public async mounted() {
        await this.getDropdownData();
        var date = new Date();
        this.fromDate =  `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear() - 1}`;
        this.toDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        this.initialDate = new Date(this.fromDate);
        this.todaysDate = new Date(this.toDate);
    }
    async getDropdownData() {
        this.wsdlService
            .getTipoDeFondos(this.userId, "")
            .then((response: AxiosResponse<FundTypeObj>) => {
                let option = new Option<FundType>();
                option.value = response.data.tipofondos;
                option.text = response.data.tipofondos.valor;
                option.disabled = false;
                this.tiposDeFondos.push(option);
                this.tipoFondo = option.value;
            });
    }
    public process() {
        console.log("this.fromDate",this.fromDate)
        console.log("this.toDate",this.toDate)
        console.log("initialDate",this.initialDate)
        console.log("todaysDate",this.todaysDate)
        this.$emit("process", this.fromDate, this.toDate, this.tipoFondo);
    }
	public setFromDate(date: Date) {
        this.fromDate =  `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        this.initialDate = date;
    }
    public setToDate(date: Date) {
        this.toDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        this.todaysDate = date;
    }
	returnHome(){
		window.location.href = GlobalConfig.PORTAL_BASE_URL
	}
}
